<h2 mat-dialog-title style="margin-bottom: -2px; font-size: 22px">
    Select Organisation
</h2>

<div style="    display: flex;
place-content: center;" class="cards swiper-slide-container">
    <mat-form-field appearance="fill">
        <mat-label></mat-label>
        <mat-select [value]="selectedOrgId">
            <mat-option *ngFor="let org of this.organizationData" [value]="org.id" (click)="onClickOption(org.id)">
                {{ org.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>



<div mat-dialog-actions style="display: flex; justify-content: center">
    <button mat-button (click)="closeModal()">Cancel</button>
    <button mat-button (click)="login()">Login</button>
</div>